import React, { useEffect } from 'react';
import { MobileServicesPageTemplate } from '../MobileServicesPageTemplate';
import { _services } from '../../copy';
import image from './Cognitive_Mobile@2x.png';
import { Youtube_CO } from '../Youtube/Youtube_CO';
import { HomeDivider } from '../../Homepage/HomeDivider';
import { Appointment } from '../../Mobile/Homepage/Appointment/Appointment';
import { Services } from '../Services/Services';

export const CognitivePage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const { co } = _services;
	return (
		<div>
			<MobileServicesPageTemplate
				img={image}
				headline={co.headline}
				copy1={co.copy[0]}
				copy2={co.copy[1]}
				button={_services.pageButton}
			/>
			<Youtube_CO />
			<HomeDivider />
			<Services top={`services-page-top-mobile`} />
			<HomeDivider />
			<Appointment />
		</div>
	);
};
